let loadingTask = false

const GM_URL = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_API_KEY}&libraries=places`

export function loadGooglePlaces() {
  if (window.google) return Promise.resolve()
  if (loadingTask) return loadingTask

  loadingTask = new Promise((resolve, reject) => {
    if (window.google) {
      resolve()
    } else {
      const script = document.createElement('script')

      script.setAttribute('type', 'text/javascript')
      script.setAttribute('src', GM_URL)
      script.onerror = reject
      script.onload = resolve
      document.body.appendChild(script)
    }
  })


  return loadingTask
}
